import React from "react";

const PaymentInfo = ({ payment }) => {
  return payment?.method === "online" && payment?.gateway ? <div>{payment?.ref ?? "--"}</div> : <div></div>;
};

export default PaymentInfo;
